import { FaAward } from "react-icons/fa";
import { TbBooks } from "react-icons/tb";
import { MdWork } from "react-icons/md";

const data = [
  { id: 1, icon: <FaAward />, title: "Experience", desc: "6+ Years Working" },
  { id: 2, icon: <TbBooks />, title: "Projects", desc: "80+ Completed" },
   {
    id: 3,
    icon: <MdWork />,
    title: "Organizations",
    desc: "Worked in 3+ Companies",
  },
];

export default data;
